// src/hooks/useLanguage.js
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'he', 'ru', 'es'];
const DEFAULT_LANGUAGE = 'en';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const lang = useMemo(() => {
    const potentialLang = (i18n.language || 'en').split('-')[0];
    // If the detected language is one we support, use it. Otherwise, fall back to the default.
    // This prevents URL parts like "forgot" from being treated as a language.
    return SUPPORTED_LANGUAGES.includes(potentialLang) ? potentialLang : DEFAULT_LANGUAGE;
  }, [i18n.language]);
  return lang;
};
